// vCard.js
import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const VCard = () => {
  const handleDownloadVCard = () => {
    // Datos de la vCard
    const vCardData = `
BEGIN:VCARD
VERSION:2.1
FN:MD Comunicación Visual
TEL;WORK;VOICE:+541158070675
EMAIL;TYPE=WORK:m.ponce@mdcvisual.com.ar
URL:https://www.mdcvisual.com.ar/
END:VCARD
    `;

    // Crear un blob con los datos de la vCard
    const blob = new Blob([vCardData], { type: "text/vcard" });

    // Crear un enlace para descargar el archivo
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "MDCVisual.vcf";

    // Añadir el enlace al DOM y hacer clic en él para iniciar la descarga
    document.body.appendChild(link);
    link.click();

    // Eliminar el enlace del DOM
    document.body.removeChild(link);
  };

  return (
    <button onClick={handleDownloadVCard} className="button-styles hover-text">
      <span className="tooltip-text fade">Download vCard</span>
      <Icon icon="bi:download" />
    </button>
  );
};

export default VCard;
